/* eslint-disable import/named */
import { fromJS } from 'immutable';
import { call, put, takeEvery, select } from 'redux-saga/effects';
import * as types from '../../constants';

import * as ServicesApp from '../service';

const upsellBundleReducer = state => state.get('upsellBundleReducer');

export function* getProductsDetailSaga(actions) {
  const response = yield call(ServicesApp.getProductsDetailService, actions.ids);
  const products = response ? response.products : [];

  yield put({
    type: types.CHANGE_TARGET_PRODUCT_UPSELL_BUNDLE_RESULT,
    res: products
  });
}

export function* getListUpsellBundleSaga() {
  const response = yield call(ServicesApp.getListUpsellCampaignService, 'bundle');
  yield put({
    type: types.GET_LIST_UPSELL_BUNDLE_RESULT,
    res: response
  });
}

function* putUpsellFieldCampaignCommon(field, value) {
  yield put({
    type: types.CHANGE_UPSELL_BUNDLE_PRODUCT_DETAIL_FIELD,
    payload: { field, value }
  });
}

function* getDataProductsDetail(data) {
  // get target products detail campaign
  const response = yield call(ServicesApp.getProductsDetailService, JSON.parse(data.target_ids || '[]'));
  const products = response ? response.products : [];
  yield putUpsellFieldCampaignCommon('targetProductDetail', fromJS(products));
}

function* getDetailUpsellBundleSaga(actions) {
  if (actions.id !== 'new') {
    const response = yield call(ServicesApp.getDetailCampaignUpsellService, actions.id);
    yield put({
      type: types.GET_DETAIL_CAMPAIGN_UPSELL_BUNDLE_RESULT,
      payload: { status: response && response.id > 0, data: response }
    });
    yield getDataProductsDetail(response);
  }
}

function* saveSettingUpsellBundleCampaignSaga() {
  const data = yield select(upsellBundleReducer);
  const result = yield call(ServicesApp.saveSettingUpSellCampaignService, data.get('upsellCampaign'));
  yield put({
    type: types.SAVE_SETTING_UPSELL_BUNDLE_CAMPAIGN_RESULT,
    res: result && result.success && result.id ? result.id : false
  });
}

function* changeStatusUpsellBundleSaga(action) {
  const result = yield call(ServicesApp.changeStatusCampaignUpsellService, action);
  yield put({
    type: types.CHANGE_STATUS_UPSELL_BUNDLE_RESULT,
    res: result && result.success,
    payload: action.payload
  });
}

function* deleteCampaignUpsellBundleSaga(action) {
  const result = yield call(ServicesApp.deleteCampaignUpsellV2Service, action);
  if (result && result.success) {
    yield getListUpsellBundleSaga();
  }
  yield put({
    type: types.DELETE_CAMPAIGN_UPSELL_BUNDLE_RESULT,
    res: result && result.success ? 1 : 2
  });
}

function* sagaActions() {
  yield takeEvery(types.CHANGE_TARGET_PRODUCT_UPSELL_BUNDLE, getProductsDetailSaga);
  yield takeEvery(types.GET_LIST_UPSELL_BUNDLE, getListUpsellBundleSaga);
  yield takeEvery(types.GET_DETAIL_CAMPAIGN_UPSELL_BUNDLE, getDetailUpsellBundleSaga);
  yield takeEvery(types.SAVE_SETTING_UPSELL_BUNDLE_CAMPAIGN, saveSettingUpsellBundleCampaignSaga);
  yield takeEvery(types.CHANGE_STATUS_UPSELL_BUNDLE, changeStatusUpsellBundleSaga);
  yield takeEvery(types.DELETE_CAMPAIGN_UPSELL_BUNDLE, deleteCampaignUpsellBundleSaga);
}

export default sagaActions;
